import api from '../../api';
import { blogAuthActions } from './blogAuth';

export const blogLogin = (email, password) => async (dispatch) => {
  dispatch(blogAuthActions.loginStart());
  try {
    const result = await api.blogLogin({ email, password });
    dispatch(blogAuthActions.loginSuccess({
      token: result.access_token,
      author: result.author
    }));
    return result;
  } catch (error) {
    dispatch(blogAuthActions.loginFailure(error?.description || 'Login failed'));
    throw error;
  }
};
